import { render, staticRenderFns } from "./TaskListPointModal.vue?vue&type=template&id=3a59d683&scoped=true"
import script from "./TaskListPointModal.vue?vue&type=script&lang=js"
export * from "./TaskListPointModal.vue?vue&type=script&lang=js"
import style0 from "./TaskListPointModal.vue?vue&type=style&index=0&id=3a59d683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59d683",
  null
  
)

export default component.exports